
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.084 2.083c.283-.28.707-.419 1.273-.416h13.31c.554-.005.971.134 1.25.416.28.284.418.706.417 1.27v13.314c0 .555-.139.972-.417 1.25-.277.278-.694.416-1.25.416H3.342c-.56 0-.98-.139-1.258-.416-.279-.277-.417-.694-.417-1.25V3.342c-.005-.559.133-.978.417-1.259zM10 9.167a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm-2.5 1.666c-1.306 0-2.387 1.083-2.5 2.5-.007.082 0 1.661 1.666 1.667 1.667.006 5 0 6.667 0C15 15 15.008 13.418 15 13.333c-.117-1.412-1.198-2.5-2.5-2.5h-5z","fill":"#F7936F"}})])
          )
        }
      }
    